/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 1500 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Jiale",
  title: "Hi all, I'm Jiale(Jay)",
  subTitle: emoji(
    "🚀 A passionate Full Stack Developer with 5+ years of experience building web applications using React, Vue.js, Node.js, ASP.NET Core, and other modern frameworks."
  ),
  resumeLink:
    "", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/CJ20170805",
  linkedin: "https://www.linkedin.com/in/jiale-cao-01427325b/",
  gmail: "jiale.cao2022@outlook.com",
  //gitlab: "https://gitlab.com/saadpasta",
  //facebook: "https://www.facebook.com/saad.pasta7",
  //medium: "https://medium.com/@saadpasta",
  //stackoverflow: "https://stackoverflow.com/users/10422806/saad-pasta",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I Do",
  subTitle: "Full Stack Developer focused on building responsive, scalable, and user-friendly applications",
  skills: [
    emoji("⚡ Develop modern frontends with Vue.js, React.js, Next.js, and TypeScript"),
    emoji("⚡ Build secure backends with PHP, Laravel, ASP.NET Core, Node.js, and databases"),
    emoji("⚡ Create interactive maps and visualizations with Leaflet.js and D3.js"),
    emoji("⚡ Deploy scalable solutions using cloud platforms, Git, Docker, and DevOps practices")
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
  {
    skillName: "HTML5",
    fontAwesomeClassname: "fab fa-html5"
  },
  {
    skillName: "CSS3",
    fontAwesomeClassname: "fab fa-css3-alt"
  },
  {
    skillName: "Sass",
    fontAwesomeClassname: "fab fa-sass"
  },
  {
    skillName: "JavaScript",
    fontAwesomeClassname: "fab fa-js"
  },
  // {
  //   skillName: "TypeScript",
  //   fontAwesomeClassname: "devicon-typescript-plain" // needs devicon
  // },
  {
    skillName: "React.js",
    fontAwesomeClassname: "fab fa-react"
  },
  {
    skillName: "Vue.js",
    fontAwesomeClassname: "fab fa-vuejs"
  },
  // {
  //   skillName: "Next.js",
  //   fontAwesomeClassname: "devicon-nextjs-plain" // needs devicon
  // },
  {
    skillName: "Node.js",
    fontAwesomeClassname: "fab fa-node-js"
  },
  {
    skillName: "PHP",
    fontAwesomeClassname: "fab fa-php"
  },
  {
    skillName: "Laravel",
    fontAwesomeClassname: "fab fa-laravel"
  },
  {
    skillName: "ASP.NET Core",
    fontAwesomeClassname: "fas fa-code" // no official icon, use generic
  },
  {
    skillName: "C#",
    fontAwesomeClassname: "fas fa-code"
  },
  {
    skillName: "SQL Databases",
    fontAwesomeClassname: "fas fa-database"
  },
  {
    skillName: "Leaflet",
    fontAwesomeClassname: "fas fa-map" // no official, use map
  },
  {
    skillName: "Docker",
    fontAwesomeClassname: "fab fa-docker"
  },
  {
    skillName: "Git",
    fontAwesomeClassname: "fab fa-git-alt"
  },
],

  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: false, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Harvard University",
      logo: require("./assets/images/harvardLogo.png"),
      subHeader: "Master of Science in Computer Science",
      duration: "September 2017 - April 2019",
      desc: "Participated in the research of XXX and published 3 papers.",
      descBullets: [
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      ]
    },
    {
      schoolName: "Stanford University",
      logo: require("./assets/images/stanfordLogo.png"),
      subHeader: "Bachelor of Science in Computer Science",
      duration: "September 2013 - April 2017",
      desc: "Ranked top 10% in the program. Took courses about Software Engineering, Web Security, Operating Systems, ...",
      descBullets: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit"]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "70%"
    },
    {
      Stack: "Programming",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: false, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Software Engineer",
      company: "Facebook",
      companylogo: require("./assets/images/facebookLogo.png"),
      date: "June 2018 – Present",
      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      descBullets: [
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      ]
    },
    {
      role: "Front-End Developer",
      company: "Quora",
      companylogo: require("./assets/images/quoraLogo.png"),
      date: "May 2017 – May 2018",
      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
    },
    {
      role: "Software Engineer Intern",
      company: "Airbnb",
      companylogo: require("./assets/images/airbnbLogo.png"),
      date: "Jan 2015 – Sep 2015",
      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Projects",
  subtitle: "Showcasing my web development projects",
  projects: [
    {
      image: require("./assets/images/resultsmap/2.png"), // main thumbnail
      images: [
        require("./assets/images/resultsmap/2.png"),
        require("./assets/images/resultsmap/1.png"),
        require("./assets/images/resultsmap/3.png")
      ],
      projectName: "ResultsMap Build Platform",
      projectDesc: "An interactive visualization tool built with Vue 3, TypeScript, and D3.js that allows users to create, manage, and visualize complex relationships and data structures with zooming, panning, and context menus for enhanced user interaction.",
      techStack: ["Vue 3", "TypeScript", "D3.js"],
      features: [
        "Interactive Map Creation: Create sections, bubbles, and relationships dynamically",
        "Layered Visualization: Organize data into hierarchical layers (Mission, Strategic, Process, Operational)",
        "Customizable Elements: Adjust text, colors, font sizes, and weights for sections and bubbles",
        "Presentation Mode: Highlight specific layers, sections, or relationships for presentations",
        "Export Options: Export the map as PNG, PDF, or JSON",
        "Help Center: Access a built-in help center for guidance",
        "Tour Guide: Step-by-step onboarding for new users"
      ],
      footerLink: [
        {
          name: "View Live Demo",
          url: "https://results-map.vercel.app/#/"
        }
      ]
    },
    {
      image: require("./assets/images/agric/1.png"), // main thumbnail
      images: [
        require("./assets/images/agric/1.png"),
        require("./assets/images/agric/2.png"),
        require("./assets/images/agric/5.png")
      ],
      projectName: "Agricultural SaaS Platform",
      projectId: "agric",
      projectDesc: "A cloud-based platform for precision agriculture that provides real-time weather data, soil monitoring, and crop analytics to support efficient farm management.",
      techStack: ["Vue.js", "Leaflet.js", "ECharts", "Amap API", "Google Maps"],
      features: [
        "Real-time weather and climate data for informed decision-making",
        "Digital agriculture cloud for crop and soil analysis",
        "Soil database with nutrient monitoring (N, P, K, pH, Organic Matter)",
        "Interactive maps and dashboards for farm-scale insights"
      ],
      // footerLink: [
      //   {
      //     name: "View Live Demo",
      //     url: "https://results-map.vercel.app/#/"
      //   }
      // ]
    },
    {
      image: require("./assets/images/speech/1.png"), // main thumbnail
      images: [
        require("./assets/images/speech/2.png"),
        require("./assets/images/speech/5.png"),
        require("./assets/images/speech/3.png"),
        require("./assets/images/speech/4.png")
      ],
      projectName: "Multilingual Speech Recognition Platform",
      projectId: "speech",
      projectDesc: "Created a multilingual speech-recognition website using Svelte.js, allowing users to upload recordings or perform real-time speech recognition, catering to diverse language needs.",
      techStack: ["Svelte.js"],
      features: [
        "Real-time speech-to-text recognition in multiple languages",
        "Upload audio recordings for transcription",
        "Supports diverse accents and dialects",
        "Clean and responsive UI for accessibility"
      ],
      // footerLink: [
      //   {
      //     name: "View Live Demo",
      //     url: "https://results-map.vercel.app/#/"
      //   }
      // ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Google Code-In Finalist",
      subtitle:
        "First Pakistani to be selected as Google Code-in Finalist from 4000 students from 77 different countries.",
      image: require("./assets/images/codeInLogo.webp"),
      imageAlt: "Google Code-In Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dYkVvNjdNWjNybWJrbndFSHpNY2NFV1p4YmU0/view?usp=sharing"
        },
        {
          name: "Award Letter",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
        },
        {
          name: "Google Code-in Blog",
          url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
        }
      ]
    },
    {
      title: "Google Assistant Action",
      subtitle:
        "Developed a Google Assistant Action JavaScript Guru that is available on 2 Billion devices world wide.",
      image: require("./assets/images/googleAssistantLogo.webp"),
      imageAlt: "Google Assistant Action Logo",
      footerLink: [
        {
          name: "View Google Assistant Action",
          url: "https://assistant.google.com/services/a/uid/000000100ee688ee?hl=en"
        }
      ]
    },

    {
      title: "PWA Web App Developer",
      subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
      image: require("./assets/images/pwaLogo.webp"),
      imageAlt: "PWA Logo",
      footerLink: [
        {name: "Certification", url: ""},
        {
          name: "Final Project",
          url: "https://pakistan-olx-1.firebaseapp.com/"
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+92-0000000000",
  email_address: "saadpasta70@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: true // Set true to display this section, defaults to false
};

const isHireable = false; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
